import { Tag } from 'foundations-components/transitional/components/Tag';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { PlayerPauseIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PausedSLATag = () => {
  return /*#__PURE__*/_jsxs(Tag, {
    use: "default",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: PlayerPauseIcon,
      color: "icon-core-subtle",
      padding: "0",
      paddingBlock: "100",
      marginInlineEnd: "100"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaPaused"
    })]
  });
};
PausedSLATag.displayName = 'PausedSLATag';